import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  drawerContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    zIndex: 1
  },
  drawer: {
    ...(() => {
      const shared = {
        display: 'flex',
        height: '100%',
        position: 'relative',
        transition: 'width 0.3s',
        width: '380px',
        backgroundColor: capitalDesignTokens.semanticColors.background.primary
      };
      return {
        ...shared,
        '& .MuiDrawer-paper': {
          ...shared,
          padding: '16px',
          transition: 'width 0.3s'
        }
      };
    })()
  },
  drawerClosed: {
    width: '0px',
    transition: 'width 0.3s',
    '& .MuiDrawer-paper': {
      width: '0px',
      minWidth: '0px',
      overflow: 'hidden',
      padding: '0px',
      transition: 'width 0.3s'
    }
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  menuIcon: {
    position: 'fixed',
    top: '150px',
    left: '16px',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    background: 'white',
    boxShadow: 2,
    width: '40px',
    height: '40px'
  },
  storiesList: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflow: 'auto'
  },
  storyNode: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  storyTitle: {
    color: '#494A4C',
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
    padding: '0px',
    textAlign: 'left',
    justifyContent: 'flex-start',
    width: '100%',
    minWidth: '0px',
    maxWidth: '100%',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal,
    minHeight: '36px',
    '& .MuiTypography-root': {
      marginLeft: '16px'
    },
    '& .MuiButton-endIcon': {
      marginRight: '0px'
    }
  },
  tocNodeTitle: {
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    fontSize: capitalDesignTokens.foundations.typography.fontSize.h4,
    '& .MuiTypography-root': {
      marginLeft: '16px',
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
    }
  },
  accordion: {
    margin: '0px',
    width: '100%',
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    '& .MuiAccordionSummary-root': {
      padding: '0px',
      minHeight: '40px',
      marginTop: '8px',
      '&:focus': {
        outline: 'none'
      }
    },
    '& .MuiAccordionSummary-content': {
      margin: '0px 8px'
    }
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px',
    marginLeft: '20px'
  },
  expandIcon: { fontSize: 'small' },
  selectedStoryBgColor: {
    background: capitalDesignTokens.semanticColors.callToAction.primaryActionLight
  },
  selectedStory: {
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '0px',
      top: '0px',
      bottom: '0px',
      width: '4px',
      background: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium
    }
  },
  storyStarIcon: {
    color: capitalDesignTokens.semanticColors.background.warningMedium
  },
  storyVisibilityIcon: {
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    height: '16px',
    width: '16px',
    cursor: 'pointer'
  },
  storyVisibilityIconDisabled: {
    color: capitalDesignTokens.semanticColors.foreground.disabled,
  },
  storyDisabled: {
    '& .MuiTypography-root': {
      color: capitalDesignTokens.semanticColors.foreground.disabled,
      marginLeft: '16px',
    }
  },
  storyTitleContainer: {
    width: '100%',
  }
});
